export default __webpack_public_path__ + "static/media/leo.20a8a52c.jpg";